import React, { useState } from "react";

import { Link } from "react-router-dom";

import {
    LikeTwoTone,
    DislikeTwoTone,
    QuestionCircleTwoTone,
    CheckCircleTwoTone,
    CheckOutlined,
} from "@ant-design/icons";

import { CATLOG_FORMAT_XTM, CATLOG_FORMAT_SALESFORCE } from "../../../config/const";

import {
    LAYOUT_MANAGER_QTASK_RECEIVABLE_SALESFORCE,
    LAYOUT_MANAGER_QTASK_RECEIVABLE_XTM,
} from "../../../layouts/manager/navigation";

import { EditableSelectValue } from "../../../core/components/widget";
import { Table, Space, Button, Divider, Popconfirm } from "antd";

import Settings from "../../job/task/settings";

import DateTimeTask from "../../job/task/status/datetime";

const Tasks = (props) => {
    /*
    const [task, setTask] = useState(null);
    */
    //const quoteId = props.quote.id;

    const getServiceName = (service) =>
        props.servicesById && service ? props.servicesById[service].name : service ? service.name : "";
    const getUnitName = (unit) => (props.unitsById && unit ? props.unitsById[unit].name : unit ? unit.name : "");
    const getLanguageCode = (l) => (props.languagesById && l ? props.languagesById[l].name : l ? l.name : "");
    const getLanguagePairCode = (lp) =>
        props.languagePairsById && lp ? props.languagePairsById[lp].name : lp ? lp.name : "";

    const displayCatlog = props.full ? true : false;
    //const readOnly = props.readOnly;

    const expandedRowRender = (record) => {
        const columns = [
            { title: "", dataIndex: "", key: "" },
            { title: "Count", dataIndex: "count", key: "count", align: "right", width: 50 },
            {
                title: "Type",
                dataIndex: "catlogValue",
                key: "catlogValue",
                width: 300,
                render: (catvalue) => <span>{catvalue.name} </span>,
            },
        ];

        return (
            <Table
                rowKey={(row) => row.id}
                columns={columns}
                dataSource={(record.qTaskFinances || []).filter((item) => item.subtotalValue > 0)}
                pagination={false}
                title={() => <Settings task={record} />}
            />
        );
    };

    const columns = () => {
        const __columns = [
            /*
            { title: "#", dataIndex: "code", key: "order", width: 50 },
            */
            {
                title: "Service",
                dataIndex: "service",
                key: "service",
                render: (service, record) => {
                    return <>{getServiceName(service)}</>;
                },
            },
            {
                title: "Category",
                dataIndex: "serviceCategory",
                key: "category",
                render: (category, record) => {
                    if (category) {
                        return <>{category?.name}</>;
                    } else {
                        return null;
                    }
                },
            },
            {
                title: "Language(s)",
                dataIndex: "languageType",
                key: "languageType",
                render: (type, record) => {
                    if (type == "Single") {
                        if (record.languageFamily == "LTR" || record.languageFamily == "RTL") {
                            return <>{record.languageFamily}</>;
                        }
                        return <>{getLanguageCode(record.language)}</>;
                    } else {
                        return <>{getLanguagePairCode(record.languagePair)}</>;
                    }
                },
            },
            {
                title: "Unit",
                dataIndex: "baseUnit",
                key: "unit",
                render: (unit, record) => {
                    if (unit) {
                        if (record.isWord) {
                            return <>{record.effectiveWordCount} WC</>;
                        } else {
                            return (
                                <>
                                    {record.baseUnitAmount} {getUnitName(unit)}
                                </>
                            );
                        }
                    }
                },
            },
        ];

        /* completar condición */
        if (props.allowEdit || props.acceptTask) {
            __columns.push({
                title: "Action",
                key: "operation",
                align: "center",
                render: (record) => {
                    if (props.allowEdit) {
                        return (
                            <Space split={<Divider type="vertical" />}>
                                <Button
                                    size="small"
                                    type="link"
                                    block
                                    onClick={() => props.onModalEdit(record)}
                                    disabled={props.isModalActive || props.actionLoading}
                                >
                                    Edit
                                </Button>
                                {record.catlog && record.catlog.id === CATLOG_FORMAT_XTM && (
                                    <Link to={LAYOUT_MANAGER_QTASK_RECEIVABLE_XTM(record.id)}>Words</Link>
                                )}

                                {record.catlog && record.catlog.id === CATLOG_FORMAT_SALESFORCE && (
                                    <Link to={LAYOUT_MANAGER_QTASK_RECEIVABLE_SALESFORCE(record.id)}>Words</Link>
                                )}

                                <Popconfirm
                                    title="Are you sure?"
                                    onConfirm={() => props.removeTask(props.quote.id, record.id)}
                                    okText="Yes"
                                    cancelText="No"
                                    disabled={props.actionLoading}
                                >
                                    <Button type="link" disabled={props.actionLoading}>
                                        Delete
                                    </Button>
                                </Popconfirm>
                            </Space>
                        );
                    }
                },
            });
        }
        /*
        __columns.push({
            title: "Action",
            key: "action2",
            align: "center",
            render: (text, record) => <Col flex="240px" style={{ paddingTop: "4px" }}></Col>,
        });
*/
        return __columns;
    };

    return (
        <>
            {displayCatlog && (
                <Table
                    size="small"
                    className="components-table-demo-nested"
                    columns={columns()}
                    expandable={{
                        expandedRowRender: (record) => expandedRowRender(record),
                        rowExpandable: (record) => record.catlog,
                    }}
                    dataSource={props.quote.qTasks}
                    rowKey={(row) => row.id}
                    pagination={false}
                />
            )}

            {!displayCatlog && (
                <Table
                    rowKey={(row) => row.id}
                    size="small"
                    className="components-table-demo-nested"
                    columns={columns()}
                    dataSource={props.quote.qTasks}
                    pagination={false}
                />
            )}
        </>
    );
};

export default Tasks;
